<template>
  <div class="steps" id="thankYou">
    <h2>送信完了しました</h2>
    <div class="message">
    <p>
      このたびはお問い合わせいただきありがとうございます。<br><br>

      ご入力いただいたメールアドレス宛に受付確認メールをお送りしましたのでご確認ください。

      確認メールが届いていない場合には、メールアドレスが誤っているか、確認メールが迷惑メールフォルダ等に振り分けられている可能性がありますので、再度ご確認をお願いいたします。<br><br>

      なお、携帯・スマートフォンのキャリアメールアドレスでは、お客様が迷惑メール対策等でメールが届かない場合がございます。PCメールのご入力をしていただくか、以下のドメインを受信できるように設定してください。</p><br>

      <p>atelier-tamari.com</p><br>

      <p>万が一3日以上経過しても返信がない場合は、恐れ入りますが直接お電話ください。<br>
      <a href="tel:06-6585-0154"> 06-6585-0154 </a><br><br>

      なお、お問い合わせ内容につきましては、通常3営業日程度を目処に、弊社担当者よりご回答させていただきます。
      いましばらくお待ちくださいませ。<br><br>

      今後ともご愛顧賜りますようよろしくお願い申し上げます。<br><br><br>


      アトリエタマリ
    </p>

    <p class="bottom_menu1 bottom_menu">&lt;&emsp;<a href="http://atelier-tamari.com/">アトリエタマリ サイトTOPに戻る</a></p>
    <p class="bottom_menu">&lt;&emsp;<span @click="pushTo('ModuleA', {})">シミュレーターTOPに戻る</span></p>
    </div>
  </div>
</template>

<script>
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
export default {
  name: "ThankYou",
  setup(){
    const {pushTo} = useRoutePush()
    return {pushTo}
  }
}
</script>

<style scoped>
#thankYou {
  
}
#thankYou h2 {
  font-weight: 400;
  padding-top: 40px;
  margin-bottom: 40px;
  font-size: 1.6rem;
  text-align: center;
}
#thankYou .message {
  width: 90%;
  max-width: 800px;
  margin: auto;
  text-align: left;
  line-height: 1.8;
  padding-bottom: 100px;
}
#thankYou .bottom_menu1 {
  margin: 60px 0 10px;
}
@media screen and (max-width: 724px) {
  #thankYou h2 {
  font-size: 1.6rem;
  }
  #thankYou .message {
    font-size: .8rem;
  }
}
</style>
